import enElementUi from 'element-ui/lib/locale/lang/en'

module.exports = {
    common: {
        // UI ELEMENT
        submit: 'Submit',
        cancel: 'Cancel',
        sendCode: 'Send Code',
        verifyCode: 'Verification Code',
        reminder: 'Reminder',
        operation: 'Operation',
        statusNormal: "normal",
        statusDisabled: "disabled",
        // MSG
        sendCodeTip: 'We will send verification code to the email.',
        sendCodeSuccess: 'Sent verification code successfully',
        codeSent: 'Verification code has been sent, please resend after 5 minutes',
        sendCodeFail: 'sent verification code unsuccessfully, please try later',
        emailNotRegister: 'The email is not registered',
        usernameRequried: 'Username is required',
        usernameFormat: 'Username is 4-16 characters, including letter, number and underscore, starts with letter',
        emailRequried: 'Email is required',
        emailFormat: 'Please input a valid email',
        verifyCodeRequried: 'Verification code is required',
        verifyCodeFormat: 'Please input a valid verification code',
        veriryCodeMismatch: 'Incorrect or expired verification code',        
        passwordRequried: 'Password is required',
        passwordFormat: 'Password is 8-20 characters, contains at least upper/lowercase letters and number',      
        noData: 'Temporarily no data',
        tyrLater: 'Service is unavailable, please try again later',
        copySuccess: 'Copy success',
        copyFailed: 'Copy failed',
    },
    index: {
        // UI ELEMENT
        documentation: 'Documentation',
        login: 'Log In',
        signup: 'Sign Up',
        logout: 'Log Out',
        lang: '中文',
        gatewayTitle: 'Gateway to the Wanchain Network',
        gatewayInfo: 'Our easy to use API provides users with secure and dependable access to the full array of Wanchain node services. iWan allows you to focus on building great decentralized applications, while the infrastructure is managed for you.',
        benefitTitle: 'WHY CHOOSE IWAN',
        benefit1: 'NO MORE SELF-HOSTED NODES',
        benefit1info: 'We eliminate the need to install, configure, and maintain costly blockchain infrastructure.',
        benefit2: 'RELIABLE AND FAST TO DEPLOY',
        benefit2info: 'Our RPC server offers top-tier reliability and helps you quickly deploy your application.',
        benefit3: 'CROSS-CHAIN ABILITY',
        benefit3info: 'Access Cross-chain ability seamlessly without the hassle of managing the infrastructure for different blockchains.',
        summary: 'EFFORTLESSLY ACCESS WANCHAIN\'S CROSS-CHAIN ECOSYSTEM',
        copyright: '©WANCHAIN FOUNDATION LTD 2019 all rights reserved',
        // MSG
        logoutWndInfo: 'Are you sure to log out?',
    },
    signup: {
        // UI ELEMENT
        title: 'Get Started for Free',
        username: 'Username',
        email: 'Email Address',
        password: 'Password',
        confirm: 'Confirm Password',
        signup: 'Sign Up',
        privacyBegin: 'Signing up signifies you have read and agree to the',
        service: 'Terms of Service',
        privacyAnd: ' and',
        privacy: 'Privacy Policy',
        privacyEnd: '.',
        haveAccount: 'Already have an account?',
        login: 'Log In',
        // MSG
        usernameUsed: 'Username has been used',
        emailUsed: 'Email has been registered',
        confirmPwdRequried: 'Confirm password is required',
        confirmPwdMismatch: 'Password and confirm password don\'t match',
        registerSuccess: 'Register successfully'
    },
    login: {
        // UI ELEMENT
        title: 'Log In to Your Account',
        user: 'Username / Email',
        password: 'Password',
        login: 'Log In',
        forgotPwd: 'Forgot Your Password?',
        notMember: 'Not a member yet?',
        signup: 'Sign Up',
        // MSG
        emailNameRequired: 'Email or username is required',
        emailNameFormat: 'Please input a valid username or email',
        incorrectPwd: 'Incorrect username/email or password',
        accountAbnormal: 'Account abnormal, please contact administrator'
    },
    resetPwd: {
        // UI ELEMENT
        title: 'Reset Password',
        email: 'Email Address',
        reset: 'Reset Password',
        back: 'Back to',
        login: 'Log In',
        // MSG
        mailReminder: 'A temporary password was sent to your email, please log in with it and change the password'
    },
    projectManage: {
        // UI ELEMENT
        // main window
        title: 'Project Management',
        create: 'Create Project',
        edit: 'Edit',
        delete: 'Delete',
        name: 'PROJECT NAME',
        apikey: 'API KEY',
        secret: 'SECRET KEY',
        serviceType: 'SERVICE TYPE',
        status: 'STATUS',
        createDate: 'CREATION DATE',
        operation: 'OPERATION',
        // endpoint
        endpoint: 'Endpoint',
        // create window
        createWndTitle: 'Create',
        createWndName: 'NAME',
        // edit window
        editWndTitle: 'Edit',
        editWndName: 'NAME',
        // delete window
        deleteWndInfo: 'Are you sure to delete this project?',
        // MSG
        nameRequired: 'Input project name',
        nameFormat: '1-16 characters, including letter, number and underscore',
        nameUsed: 'Project name has been used',
        deleteSuccess: 'Delete project successfully',
        editSuccess: 'Modify project successfully',
        createSuccess: 'Create project successfully'
    },
    accountManage: {
        // UI ELEMENT
        title: 'My Account',
        accountInfo: 'Account Information',
        changePwd: 'Change Password',
        changeEmail: 'Change Email Address'
    },
    accountInfo: {
        // UI ELEMENT
        title: 'Account Information',
        username: 'User Name',
        email: 'Email Address',
        role: 'Role',
        level: 'Level',
        status: 'Status',
        registerDate: 'Registration Date',
        lastDate: 'Last Login Date',
        lastIp: 'Last Login IP',         
    },
    changePwd: {
        // UI ELEMENT
        title: 'Change Password',
        oldPassword: 'Input Old Password',
        newPassword: 'Input New Password',
        retypePassword: 'Retype New Password',
        // MSG
        oldPwdRequried: 'Input Current Password',
        newPwdRequried: 'Input New Password',
        confirmNewPwd: 'Confirm New Password',
        confirmNewPwdMismatch: 'The new password and confirm password do not match',
        changeSuccess: 'Change password successfully',
        oldPwdIncorrect: 'The old password is incorrect'
    },
    changeEmail: {
        // UI ELEMENT
        title: 'Change Email Address',
        password: 'Input Password',
        newEmail: 'New Email Address',
        // MSG
        changeSuccess: 'Change email successfully',
        pwdIncorrect: 'The password is incorrect'
    },
    admin: {
        // UI ELEMENT
        title: 'Administrator',
        users: 'Users',
        projects: 'Projects',
        totalUsers: 'Total users:',
        totalProjects: ', total projects:',
        searchUser: 'Search by Username / Email',
        searchProject: 'Search by Username / Email / API key'
    },
    stats: {
        // UI ELEMENT
        title: 'Statistics',
        allProjects: 'All Projects',
        last24h: 'Last 24 Hours',
        last7d: 'Last 7 Days',
        last30d: 'Last 30 Days',
        totalMethodCalls: 'Total Method Calls',
        projectMethodCalls: 'Project Method Calls',
        topnMethodCalls: 'Method Calls ',
        topnMethodCallsSummary: 'summary',
        chartHeatmap: 'Calls Heatmap',
    },
    ...enElementUi
}


// WEBPACK FOOTER //
// ./src/assets/i18n/en-us.js